<template>
  <div class="row" >
    <div class="col-12">
      <colors alpha :mode="mode"/>
    </div>
  </div>
</template>

<script>
import Colors from "@/js/components/editor/theme/Colors.vue";
import { mapGetters } from "vuex";
import * as getters from "@/js/store/modules/getters";

export default {
  name: "Background",
  components: { Colors },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED
    }),
  }
};
</script>

<style scoped>

</style>